import { getAPI } from '@/api'

// CloudStack remains authoritative for account/domain authorization.
export function resourceScope (user) {
  if (!user?.domainid) throw new Error('Your account information is unavailable. Please sign in again.')
  const scope = { listall: true, domainid: user.domainid, ignoreproject: true }
  if (['DomainAdmin', 'Admin'].includes(user.roletype)) {
    scope.isrecursive = true
  } else if (user.roletype !== 'Admin') {
    if (!user.account) throw new Error('Your account information is unavailable. Please sign in again.')
    scope.account = user.account
  }
  return scope
}

export async function listAll (command, key, params = {}) {
  const items = []
  const seen = new Set()
  for (let page = 1; ; page++) {
    const response = await getAPI(command, { ...params, page, pagesize: 500 })
    const body = response && response[command.toLowerCase() + 'response']
    if (!body || body.errorcode) throw new Error('Unable to load cloud resources.')
    const batch = body[key] || []
    if (!batch.length) return items
    const fresh = batch.filter(item => !seen.has(item.id))
    if (!fresh.length) throw new Error('The server returned a repeated page. Please refresh and try again.')
    fresh.forEach(item => seen.add(item.id))
    items.push(...fresh)
    if (body.count !== undefined && items.length >= Number(body.count)) return items
  }
}

export function isCustomerAccount (account, user) {
  const own = account.id === user.accountid ||
    (account.name === user.account && account.domainid === user.domainid)
  return !!account.name && account.name !== 'system' && !own &&
    (account.type === undefined || Number(account.type) === 0)
}

export function belongsToAccount (vm, account) {
  if (vm.accountid && account.id) return vm.accountid === account.id
  return !!vm.domainid && vm.domainid === account.domainid && vm.account === account.name
}

export function errorText (error, fallback = 'The request could not be completed.') {
  // Provider text can contain Java exceptions, internal paths or credentials.
  // Render fixed instructions; retain the original rejection for diagnostics.
  if (error?.code === 'NOVUS_JOB_TIMEOUT') return 'The operation is still unconfirmed. Refresh the server status before submitting another request.'
  if (error?.code === 'NOVUS_JOB_FAILED') return 'The server operation failed. Refresh its status and contact support if the issue continues.'
  const status = Number(error?.response?.status)
  if (status === 401) return 'Your session or permissions could not be verified. Sign in again or contact support.'
  if (status === 403) return 'Your account does not have permission for this action. Contact support.'
  if (status === 404) return 'The requested resource is unavailable.'
  if (status === 429) return 'Too many requests. Wait before submitting another request.'
  if (error?.isAxiosError && !error.response) return 'The connection was interrupted and the request outcome is unconfirmed. Refresh the server status before submitting another request.'
  return fallback
}
